import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { deepCompare } from "@website/utils/deep-compare";
import { ReserveCommentPopupScroll } from "@website/widget/reserve-comment-popup-scroll";
import { ReserveCommentPopupPropertiesTypes } from "@website/widget/reserve-comments-layout/reserve-comment-popup/reserve-comment-popup.types";
import { memo } from "react";

const Component = ({
  hotelTitle,
  rate,
  comments,
  onClose,
  open,
  onLoadMore,
  isLoading,
  onLoadFilter,
  filters
}: ReserveCommentPopupPropertiesTypes) => (
  <Modal
    className="z-40 overflow-y-auto !px-0 md:h-[919px]"
    onClose={onClose.bind(null, false)}
    showCloseButton
    open={open}
    title="نظرات"
    titleClassName="!text-subtitle-1"
    headerStyle="px-6 !h-[60px] lg:!h-auto fixed lg:static lg:pt-0 top-0 z-20 bg-white"
  >
    <div className="relative justify-center bg-white lg:w-[900px]">
      {hotelTitle && (
        <div className="text-body-2 text-on-surface-medium-emphasis px-6 pb-2 pt-9 lg:pt-1">
          {hotelTitle}
        </div>
      )}
      <div className="overflow-y-scroll lg:h-[75vh]">
        <ReserveCommentPopupScroll
          comments={comments}
          filters={filters}
          isLoading={isLoading}
          onLoadFilter={onLoadFilter}
          onLoadMore={onLoadMore}
          rate={rate}
        />
      </div>
      <div className="hidden h-auto w-full bg-white px-6 pt-3 text-left lg:block">
        <Button
          onClick={onClose}
          variant="outline"
          color="neutral"
          className="text-left"
          text="بستن"
        />
      </div>
    </div>
  </Modal>
);
export const ReserveCommentPopup = memo(Component, deepCompare);
